import Authenticated from 'Components/Layouts/Authenticated';
import { MailLink } from "Components/Utilities";

export default function Faq() {

    const faqs = [
        {
            question: 'When does it start?',
            answer: 'The day will start with registration from 8:30am, including access to the exhibition area. The plenary ' +
                'will start promptly at 10:30am, so please arrange travel to be there no later than 9:45am. The meeting will ' +
                'finish by 5:00pm but please allow plenty of time after the event when planning ' +
                'your journey so you can make your travel bookings.'
        },
        {
            question: 'Where is the Event?',
            answer: (
                <>
                    The event will be held at:
                    <br />
                    <b className={"font-bold"}>Coventry Building Society Arena</b>
                    <br />
                    Judds Lane
                    <br />
                    Longford
                    <br />
                    Coventry
                    <br />
                    CV6 6AQ
                </>
            ),
        },
        {
            question: 'When do I need to confirm attendance?',
            answer: 'Please confirm attendance as soon as possible and by 6 October at the latest.'
        },
        {
            question: 'What shall I wear?',
            answer: 'The usual business dress, just as you’d wear to head into your workplace.'
        },
        {
            question: 'Can I book accommodation?',
            answer: 'Accommodation is available on the night prior to the event for those that have to ' +
                'travel over 3.5 hours to get to the venue. This can be requested through the registration platform.'
        },
        {
            question: 'How to book travel',
            answer: 'Travel should be booked through Concur and charged to your cost centre. ' +
                'Each attendee will need to self-book their own travel via Concur using ' +
                'their OneID login details. Communication and guidance is also on ' +
                'BootsLive. For Ireland stores each attendee will need to book their travel ' +
                'through their Stores Administrator.'
        },

        {
            question: 'Will food be provided?',
            answer: 'Yes, all meals will be provided during the event days. Please let us know about any dietary requirements when you register.'
        },
        {
            question: 'How to travel -',
            answer: (
                <ul className={"list-disc list-inside"}>
                    <li>
                        <b className={"font-bold"}>By train: </b>
                        Coventry Arena Train Station- This station is located within walking distance of
                        Coventry Building Society Arena (approx. 5 mins).
                        Coventry Train Station- The railway station is in the city centre and
                        approximately six miles away. Taxis are available outside the station and it is
                        roughly a 10 to 15 minute journey.
                    </li>
                    <li>
                       <b className={"font-bold"}>By air: </b>
                        Birmingham International Airport is a 20 minute drive away
                    </li>
                    <li>
                        <b className={"font-bold"}>By Car: </b>
                        Coventry Building Society Arena is just 800 yards from Junction 3 of the
                        M6 and within easy distance of the M1 and M40. Post code for Sat Nav- CV6
                        6AQ
                        <br />
                        There are 2000 free parking spaces onsite
                    </li>
                </ul>
            ),
        },
    ];

    return (
        <Authenticated bgColor="bg-app-green">
            <h1 className="text-black text-4xl my-8 text-center">
                FAQs
            </h1>

            <div className={'p-5 md:p-8'}>
                We've answered some of your most asked questions below to help you prepare for the Boots and
                No7 Beauty Company Autumn Leadership Meeting 2023.
            </div>

            <div className="bg-white/60 p-5 md:p-8">
                <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-6">
                    {faqs.map((faq, key) => (
                        <div>
                            <div className={"font-bold"}>
                                {faq.question}
                            </div>

                            <div className={"font-light"}>
                                {faq.answer}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Authenticated>
    )
}
